/**
 * File mega-menu.js.
 */

//import { closeSearch } from './search.js'

const megaItems = document.querySelectorAll(
    '#lw-primary-menu .mega-item, .lw-hamburger-button.mega-item');

if (megaItems) {
    function wrap(el, wrapper) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.classList.add('mega-sub-menu');
        wrapper.appendChild(el);
    }

    megaItems.forEach((megaItem) => {
        let firstSubMenu;
        if (megaItem.querySelector('.sub-menu')) {
            firstSubMenu = megaItem.querySelector('.sub-menu');
            wrap(firstSubMenu, document.createElement('div'));
            firstSubMenu.classList.remove('sub-menu');
            firstSubMenu.classList.add('lw-mega-menu');
        }
        megaItem.classList.remove('menu-item-has-children');

        const megaItemLink = megaItem.querySelector('.mega-item-child');
        megaItemLink.addEventListener('click', function(e) {
            // Check if window width is equal to or less than 767px
            if (window.innerWidth <= 767) {
                document.body.classList.add('mega-menu-active');
            }
            e.preventDefault();
            closeSearch();

            if (megaItem.classList.contains('active')) {
                megaItem.classList.remove('active');
            } else {
                megaItems.forEach((megaItem) => megaItem.classList.remove(
                    'active'));
                megaItem.classList.add('active');
            }

            const activeItems = megaItemLink.parentNode.querySelectorAll(
                '.current-menu-parent, .current-menu-ancestor, .current-menu-item',
            );
            if (activeItems) {
                activeItems.forEach((activeItem) => activeItem.classList.add(
                    'active'));
            }
        });
    });
}

const menuParentItems = document.querySelectorAll('.menu-item-has-children');
const allSubMenues = document.querySelectorAll('.sub-menu');

document.addEventListener('DOMContentLoaded', function() {
    // LÄGGER TILL KLICKAT ELEMENT SOM TITEL
    menuParentItems.forEach((menuParentItem) => {
        const subMenu = menuParentItem.querySelector('.sub-menu');
        const titleItem = `<li class="menu-title"><a href="${menuParentItem.children[0].href}">${menuParentItem.children[0].textContent}</a></li>`;
        if (subMenu) {
            subMenu.insertAdjacentHTML('afterbegin', titleItem);
        }
    });

    // LÄGGER TILL EN BAKÅTKNAPP I UNDERMENYERNA (FÖR MOBIL)
    allSubMenues.forEach((subMenu) => {
        const backBtn = /*html*/ `<div class="sub-back"></div>`;
        subMenu.insertAdjacentHTML('afterbegin', backBtn);
    });
});

document.addEventListener('click', function(e) {
    // ÖPPNAR UNDERMENYERNA I MEGAMENYN
    if (e.target.matches('.menu-item-has-children')) {
        const selectedMenuItem = e.target;
        const parent = e.target.parentNode;
        const menuItemsHasChildren = parent.querySelectorAll(
            '.menu-item-has-children');

        if (selectedMenuItem.classList.contains('active')) {
            selectedMenuItem.classList.remove('active');
        } else {
            menuItemsHasChildren.forEach((menuItem) => menuItem.classList.remove(
                'active'));
            selectedMenuItem.classList.add('active');
        }
    }

    // BACKAR I MEGAMENYN
    if (e.target.matches('.sub-back')) {
        const parent = e.target.parentNode.parentNode;
        if (parent.classList.contains('active')) {
            parent.classList.remove('active');
        }
    }

    // STÄNGER MENYN VID KLICK PÅ OVERLAY
    if (e.target.matches('.menu-overlay')) {
        document.body.classList.remove('mega-menu-active');
        megaItems.forEach((megaItem) => megaItem.classList.remove('active'));
        menuParentItems.forEach((menuParentItem) => {
            menuParentItem.classList.remove('active');
        });
    }
});
